import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericMessageComponent } from './generic-message.component';
import { ButtonModule } from '../button/button.module';



@NgModule({
  declarations: [GenericMessageComponent],
  imports: [
    CommonModule,
    ButtonModule
  ],
  exports: [GenericMessageComponent]
})
export class GenericMessageModule { }
